import React from 'react';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import SvgIcon from '../../SvgIcon/Base';

const SuccessIcon = ({ SuccessIconComponent }) => {
  return (
    <SuccessIconComponent.Container>
      <SvgIcon value={mediaUrls.deletePopup} />
    </SuccessIconComponent.Container>
  );
};

export default SuccessIcon;
